import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";

import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { showToast } from "../ToastManager";
import { Dropdown } from "primereact/dropdown";

import Utils from "../../utilities/Utils";

import PrestadorService from "../../service/PrestadorService";
import UsuarioService from '../../service/UsuarioService';
import RoleService from '../../service/RoleService';

const prestadorService = new PrestadorService();
const usuarioService = new UsuarioService();

const CadastrarPrestador = () => {
    const iss = localStorage.getItem('iss');
    const history = useHistory();

    let prestadorNovo = {
        name: null,
        cpf: null,
        email: null,
        telefone: null,
        data_nascimento: null,
        user_id: 0,
    };

    const [prestador, setPrestador] = useState(prestadorNovo);
    const [usuario, setUsuarios] = useState([]);
    const [selectedUsuario, setSelectedUsuario] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);

    const { id } = useParams();

    const initUsuarios = useCallback(async () => {
        setLoading(true);

        try {
            const data = await usuarioService.listAllUsers(iss);
            const updatedItems = data.data.rows.map(({ username, companiesRoles, emailConfirmed, ativo, excluido, isEmpresaAdm, prestador, profile, createdAt, updatedAt, ...rest }) => rest);
            setUsuarios(updatedItems);
            if (updatedItems.length === 1) {
                prestador.user_id = updatedItems[0].id
                prestador.email = updatedItems[0].email
                setSelectedUsuario(updatedItems[0])
            }
        } catch (error) {
            console.error("Erro ao carregar usuários:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar usuários' });
        } finally {
            setLoading(false);
        }
    }, [iss]);

    useEffect(() => {
        initUsuarios();
    }, [initUsuarios]);

    useEffect(() => {
        const loadData = async () => {
            if (id && !dataLoaded) {
                try {
                    setLoading(true);
                    const data = await prestadorService.getPrestador(iss, id);
                    const prestadorNovo = data.data.rows[0];

                    prestadorNovo.data_nascimento = Utils.formatData(prestadorNovo.data_nascimento)
                    var usuario = {
                        id: prestadorNovo.user.id,
                        email: prestadorNovo.email
                    }

                    setSelectedUsuario(usuario)
                    setTimeout(() => {
                        setPrestador(prestadorNovo);
                    }, 200);
                    setDataLoaded(true);
                } catch (error) {
                    console.error("Erro ao carregar dados:", error);
                } finally {
                    setLoading(false);
                }
            }
        }
        loadData();
    }, [dataLoaded, id, iss]);

    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';
        let _prestador = { ...prestador };

        if (checkbox) {
            val = e.checked;
        }

        if (name === 'user_id') {
            setSelectedUsuario(e.value)
            _prestador.email = e.value.email;
            val = e.value.id;
        }

        if (name === 'cpf') {
            let c = String(val).replace(/[^\d]/g, '')
            if (c.length == 11 && !Utils.validateCPF(c)) {
                showToast({ severity: 'error', summary: 'Error', detail: 'CPF inválido' });
                return;
            }

            val = Utils.formatCnpj(val);
        }

        // Verifica se o nome tem um ponto
        if (name.includes('.')) {
            const [parent, child] = name.split('.'); // Divide o nome em pai e filho
            if (!_prestador[parent]) {
                _prestador[parent] = {}; // Cria o objeto pai se não existir
            }
            _prestador[parent][child] = val; // Define o valor do atributo filho
        } else {
            if (list) {
                _prestador[name] = val;
            } else {
                _prestador[name] = val; // Define o valor diretamente se não houver aninhamento
            }

        }

        setPrestador(_prestador);

    }

    const cadastrar = () => {
        setSubmitted(true);
        if (prestador.nome && prestador.cpf && prestador.email && prestador.telefone && prestador.data_nascimento) {
            let _prestador = { ...prestador };
            _prestador.cpf = String(prestador.cpf).replace(/[^\d]/g, '')
            const [day, month, year] = _prestador.data_nascimento.split("/");
            _prestador.data_nascimento = `${year}-${month}-${day} 00:00:00`;
            setLoading(true)

            if (prestador.id != null) {
                prestadorService.putPrestador(iss, _prestador, prestador.id).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de prestador', detail: 'Prestador editada com sucesso' });
                    history.push('/prestador/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar prestador' });
                }).finally(() => { setLoading(false) });
            } else {
                prestadorService.postPrestador(iss, _prestador).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de prestador', detail: 'Prestador cadastrada com sucesso' });
                    history.push('/prestador/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            }


        } else {
            showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: 'Preencha todos os campos' });
        }

    }

    const handleKeyDown = (event, name) => {
        const { key } = event;
        const lastValue = prestador[name] || '';
        let _prestador = { ...prestador };
        if (key === 'Backspace') {
            const input = event.target;
            let cursorPos = input.selectionStart;
            if (cursorPos > 0 && (input.value[cursorPos - 1] === '.' || input.value[cursorPos - 1] === '-')) {
                event.preventDefault(); // Prevent default to manually handle backspace
                let newValue = lastValue.substring(0, cursorPos - 1) + lastValue.substring(cursorPos);
                newValue = newValue.replace(/\D/g, '');
                _prestador.cpf = Utils.formatCpf(newValue); // Apply mask after removal
                setPrestador(_prestador);
            }
        }
    };

    const verificaSeExisteCPFEmail = (e) => {
        const val = (e.target && e.target.value) || '';

        if (val.email) {
            // Se contém @, trata como email
            verificaSeExisteEmail(e);
        } else {
            // Caso contrário, trata como CPF
            verificaSeExisteCPF(e);
        }
    };

    const verificaSeExisteCPF = async (e) => {
        let val = (e.target && e.target.value) || '';

        const cpfLimpo = String(val).replace(/[^\d]/g, '');

        if (cpfLimpo.length === 11) {
            try {
                setLoading(true);
                const search = `cpf=${cpfLimpo}`;
                const data = await prestadorService.getPrestadorFilter(iss, search);

                if (data.data.count > 0) {
                    showToast({
                        severity: 'error',
                        summary: 'Conflito',
                        detail: 'CPF já cadastrado'
                    });
                    setPrestador(prev => ({ ...prev, cpf: '' }));
                }
            } catch (error) {
                console.error('Erro ao verificar CPF:', error);
                showToast({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao verificar disponibilidade do CPF'
                });
            } finally {
                setLoading(false);
            }
        }
    };

    const verificaSeExisteEmail = async (e) => {
        let val = (e.target && e.target.value.email) || '';

        // Atualiza o estado do campo imediatamente para melhorar a experiência do usuário
        onInputChange(e, 'user_id');

        // Verifica se é um email válido antes de fazer a requisição
        if (val && val.includes('@') && val.includes('.')) {
            try {
                setLoading(true);
                const search = `email=${val}`;
                const data = await prestadorService.getPrestadorFilter(iss, search);

                if (data.data.count > 0) {
                    showToast({
                        severity: 'error',
                        summary: 'Conflito',
                        detail: 'Profissional já cadastrado para esse usuário'
                    });
                    // Opcional: limpar o campo ou marcar como inválido
                    setPrestador(prev => ({ ...prev, email: '' }));
                }
            } catch (error) {
                console.error('Erro ao verificar email:', error);
                showToast({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Erro ao verificar disponibilidade do email'
                });
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="grid">
            <h4>Informações do profissional</h4>
            <div className="col-12">
                <div className="card">

                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <Dropdown optionLabel="email" value={selectedUsuario}
                                    className={classNames({ 'p-invalid': submitted && !prestador.user_id })}
                                    options={usuario}
                                    disabled={RoleService.isAdmin()}
                                    onChange={(e) => {
                                        verificaSeExisteCPFEmail(e)
                                    }}
                                />
                                <label htmlFor="user_id">Usuário</label>
                            </span>
                            {submitted && !selectedUsuario &&
                                <small className="p-invalid">Usuário é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <InputMask
                                    onChange={(e) => { onInputChange(e, 'cpf'); }}
                                    onBlur={(e) => { verificaSeExisteCPFEmail(e); }}
                                    onKeyDown={handleKeyDown}
                                    value={Utils.formatCpf(prestador.cpf)}
                                    required
                                    className={classNames({ 'p-invalid': submitted && !prestador.cpf })}
                                    id="cpf"
                                    type="text"
                                    mask={"999.999.999-99"}
                                    unmask={false}
                                />
                                <label htmlFor="cpf">CPF</label>
                            </span>
                            {submitted && !prestador.cpf && <small className="p-invalid">CPF é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText value={prestador.nome} onChange={(e) => onInputChange(e, 'nome')}
                                    className={classNames({ 'p-invalid': submitted && !prestador.nome })} required id="nome" type="text"

                                />
                                <label htmlFor="nome">Nome</label>
                            </span>
                            {submitted && !prestador.nome && <small className="p-invalid">Nome é obrigatório.</small>}
                        </div>

                        <div style={{ marginTop: 10 }} className="field col-6">
                            <span className="p-float-label">
                                <InputText value={prestador.email}
                                    onBlur={(e) => verificaSeExisteCPFEmail(e)}
                                    onChange={(e) => onInputChange(e, 'email')}
                                    disabled={true}
                                    className={classNames({ 'p-invalid': submitted && (!prestador.email || (prestador.email != null && !prestador.email.includes('@'))) })}
                                    required
                                    id="email" type="text" />
                                <label htmlFor="email">Email</label>
                            </span>
                            {submitted && !prestador.email &&
                                <small className="p-invalid">Email é obrigatório.</small>}


                            {submitted && prestador.email != null && !prestador.email.includes('@') &&
                                <small className="p-invalid">Email inválido.</small>}

                        </div>

                        <div style={{ marginTop: 10 }} className="field col-12 md:col-2">
                            <span className="p-float-label">
                                <InputMask value={prestador.telefone}
                                    onChange={(e) => onInputChange(e, 'telefone')}
                                    mask={"(99) 9.9999-9999"}
                                    id="telefone" type="text" />
                                <label htmlFor="telefone">Telefone</label>
                            </span>
                        </div>

                        <div style={{ marginTop: 10 }} className="field col-12 md:col-4">
                            <span className="p-float-label">
                                <InputMask value={prestador.data_nascimento} onChange={(e) => onInputChange(e, 'data_nascimento')}
                                    mask={"99/99/9999"} id="data_nascimento" type="text" />
                                <label htmlFor="data_nascimento">Data Nascimento</label>
                            </span>
                        </div>

                        <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarPrestador, comparisonFn);
